import getParameterByName from './getParameterByName';

export default function handleTraditionalChinese(text) {
    if (getParameterByName('lang') === 'tc') {
        text = Chinese.s2t(text);
    }
    return text
}